import React, { useRef } from "react";
import emailjs, { send } from "emailjs-com";
import "./ContactForm.css";

const ContactForm = () => {
  const form = useRef();

  const sendEmail = (event) => {
    //event.preventDefault();

    emailjs
      .sendForm(
        process.env.SERVICE_ID,
        process.env.TEMPLATE_ID,
        form.current,
        process.env.USER_ID
      )
      .then(
        (result) => console.log(result.text),
        (error) => console.log(error.text)
      );
    //event.target.reset();
  };

  return (
    <div className="form">
      <form ref={form} onSubmit={sendEmail}>
        <label>Your Name</label>
        <input type="text" name="user_name" required></input>
        <label>Email</label>
        <input type="email" name="user_email" required></input>
        <label>Subject</label>
        <input type="text" required></input>
        <label>Message</label>
        <textarea
          rows="6"
          placeholder="Type your message here..."
          name="message"
          required
        />
        <button type="submit" value={send} className="btn">
          Submit
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
